let GrainTypeDto = {
  id: -1,
  name: null,
  variety: null,
  description: null
}

export default GrainTypeDto
